import { useDispatch, useSelector } from 'react-redux';
import { Input } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Label } from 'components';
import { types } from 'store/user/types';

const TextField = ({ label, fieldName, fieldType, suffix, containerClassName, className, labelClassName, customRef, ...rest }) => {
    const dispatch = useDispatch();
    const FieldTag = (fieldType == "password" ? Input.Password : Input);
    const value =  useSelector(state => state.user[fieldName]);
    return (
      <div className={containerClassName || ''}>
        <Label label={label} labelClassName={labelClassName} />
        <FieldTag
          prefix={fieldType != "password" && <UserOutlined className="site-form-item-icon" />}
          value={value}
          ref={customRef}
          {...rest}
          className={`custom-textfield ${className}`}
          suffix={suffix}
          onChange={value => { const payload = {}; payload[fieldName] = value.target.value; dispatch({ type: types.UPDATE_USER.SUCCESS, payload: payload }); }}
        />
      </div>
    );
  };
  
  TextField.propTypes = {
    label: PropTypes.string,
    fieldName: PropTypes.string,
    containerClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    className: PropTypes.string,
  };
  
  export default TextField;